import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Input, Icon, Select, Row } from 'antd'
import { BlazeButton } from '../../../components/CustomButtons/BlazeButton'
import { EmployeeFilterStore } from './EmployeeFilterStore'
import { filterOption } from '../../../utilities/helpers'

interface Props {
  filter: EmployeeFilterStore
}

interface State {
  isFilterApplying: boolean
}

@observer
export class EmployeeFilter extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isFilterApplying: false,
    }
  }

  render() {
    const {
      locations,
      securityRoles,
      searchText,
      filteredLocationIds,
      filteredSecurityRoleIds,
      isFiltered,
      isLoading,
      setSearchText,
      setFilteredLocationIds,
      setFilteredSecurityRoleIds,
      applyFilter,
      resetFilter,
    } = this.props.filter
    return (
      <div id='employee-filter' className='d-flex flex-wrap white-rounded-container pb-0'>
        <Input
          className='gr-filter-item gr-filter-gutter'
          prefix={<Icon type='search' />}
          placeholder='Name, email, or passcode'
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onPressEnter={applyFilter}
        />

        <Select<number[] | undefined>
          className='gr-filter-item gr-filter-gutter'
          placeholder='Location'
          allowClear={true}
          dropdownMatchSelectWidth={false}
          mode='multiple'
          value={filteredLocationIds}
          onChange={(locationValue) => setFilteredLocationIds(locationValue)}
          showArrow={true}
          filterOption={filterOption}
        >
          {locations.map((location) => (
            <Select.Option key={location.id} value={location.id}>
              {location.name}
            </Select.Option>
          ))}
        </Select>

        <Select<number[] | undefined>
          className='gr-filter-item gr-filter-gutter'
          placeholder='Security role'
          allowClear={true}
          dropdownMatchSelectWidth={false}
          mode='multiple'
          value={filteredSecurityRoleIds}
          onChange={(roleValue) => setFilteredSecurityRoleIds(roleValue)}
          showArrow={true}
          filterOption={filterOption}
        >
          {securityRoles.map((securityRole) => (
            <Select.Option key={securityRole.id} value={securityRole.id}>
              {securityRole.name}
            </Select.Option>
          ))}
        </Select>

        <Row className='gr-filter-gutter'>
          <BlazeButton
            buttonProps={{
              type: 'primary',
              onClick: () => applyFilter(),
              loading: isLoading,
            }}
            titleProps={{ title: 'Apply' }}
          />

          <BlazeButton
            buttonProps={{
              className: 'sgr-btn-ghost',
              type: 'link',
              onClick: () => resetFilter(),
              disabled: !isFiltered,
            }}
            titleProps={{ title: 'Reset' }}
          />
        </Row>
      </div>
    )
  }
}
